import { createStyles, makeStyles } from "@material-ui/core/styles";
import {
    Button,
    PageActionButton,
    PageHeaderActions,
    RelodeTheme,
    SaveIcon,
} from "@relode/core";
import * as React from "react";

import { useSettingsContext } from "./_infra/settingsProvider";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            mobileButton: {},
        }),
    {
        name: "SettingsActionBar",
    }
);

export const SettingsActionBar = () => {
    const { contact, formikProps, actions } = useSettingsContext();
    const { dirty, errors } = formikProps;

    const [saveRequired, setSaveRequired] = React.useState(false);
    React.useEffect(() => {
        const hasErrors = Object.keys(errors).length > 0;
        setSaveRequired(dirty && !hasErrors);
    }, [errors, dirty]);

    const renderSave = () => (
        <PageActionButton
            id="saveSettingsButton"
            title="save settings"
            actionType="positive"
            disabled={!saveRequired}
            onClick={async () => await actions.saveProfile(contact)}
        >
            <SaveIcon />
        </PageActionButton>
    );

    return <PageHeaderActions right={<>{renderSave()}</>} />;
};

export const MobileSettingsActions = () => {
    const { contact, formikProps, actions } = useSettingsContext();
    const { dirty, errors } = formikProps;

    const [saveRequired, setSaveRequired] = React.useState(false);
    React.useEffect(() => {
        const hasErrors = Object.keys(errors).length > 0;
        setSaveRequired(dirty && !hasErrors);
    }, [errors, dirty]);

    const renderSave = () => (
        <Button
            fullWidth
            color="primary"
            variant="contained"
            id="saveSettingsButton"
            title="save settings"
            disabled={!saveRequired}
            onClick={async () => await actions.saveProfile(contact)}
        >
            save
        </Button>
    );

    return renderSave();
};
